@if (youtubeId()) {
  <div
    class="youtube-container">
    <iframe
      [title]="mediaTitleText()"
      [src]="urlSafe()"
      allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      class="video no-border"
      loading="lazy">
    </iframe>
  </div>
}
@if (animation() && !youtubeId()) {
  <video
    #video
    [attr.muted]="(autoplay()) ? 'muted' : null"
    playsinline
    [attr.controls]="(showControls()) ? 'controls' : null"
    [attr.controlslist]="controlsList()"
    (loadedmetadata)="loadedMetadata(video)"
    (canplay)="startAutoplay(video)"
    isVideo="true"
    [attr.title]="mediaTitleText()"
    [attr.poster]="posterUrl()"
    [sharedUtilsDirectiveCommonLazyLoad]="animationUrl()"
    [shouldAutoplay]="autoplay()"
    [willLazyLoad]="willLazyLoad()">
    Your browser does not support the video tag.
  </video>
}